$(document).on('click', '#checkout', function(event) {
  $('#cart').submit();
});


function updateGiftInCart(cart) {
    let values = {};
    if (!cart || !cart.items) {
        $.getJSON('/cart.js', function (fetchedCart) {
            updateGiftInCart(fetchedCart);
        });
        return;
    }

var lastActive = $('.shipping-bar__progress .gift_line.active').last();
$('.gift_line').each(function() {
    let giftItemId = $(this).data('id');
if(giftItemId != ''){
    let isActive = $(this).hasClass('active');
    let itemExistsInCart = cart.items.some(item => item.id === giftItemId);
    if (isActive && !itemExistsInCart) {
        values[giftItemId] = 1;
    } else if (!isActive && itemExistsInCart) {
        values[giftItemId] = 0;
    }
}
});

// Outside the `.each` loop, check the attributes of `.shipping-bar__progress`
let progressBar = $('.shipping-bar__progress');
let dataId1 = progressBar.attr('data-id1');
let dataId2 = progressBar.attr('data-id2');
let dataId3 = progressBar.attr('data-id3');

// Check if these values exist in the cart and set `values` accordingly
[dataId1, dataId2, dataId3].forEach(id => {
    if (id) { // Ensure the ID is not empty or undefined
        let itemExistsInCart = cart.items.some(item => item.id === parseInt(id)); // Check if the item exists in the cart
        if (itemExistsInCart) {
            values[id] = 0; // Set value to 0 if the item does not exist in the cart
        }
    }
});

console.log(values);
    if (Object.keys(values).length > 0) {
        $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            dataType: 'json',
            data: { updates: values },
            beforeSend: function (xhr) {
            },
            success: function (cart) {
              console.log(cart);
                carthtmldataGift(); 
            },
            error: function (xhr, status, error) {
              console.error('Error updating cart1:', xhr);
              console.error('Error updating cart2:', status);
                console.error('Error updating cart3:', error);
            }
        });
    }
}
updateGiftInCart();
$(document).on('click', '[aria-controls="cart-drawer"]', function(event) {
  event.preventDefault(); 
 $('.cart-drawer').addClass('open_cartdrawer');
  $('body').addClass('js-drawer-open');
  $('.cart-overlay').show();
  
});
function drawerClose() {
  $('.cart-drawer').removeClass('open_cartdrawer');
  $('body').removeClass('js-drawer-open');
  $('.cart-overlay').hide();
  $('.PageOverlay').removeClass('is-visible');
  $('html').removeClass('no-scroll');
}
$(document).on("click", ".continue_shopping_button[type='button']", function (e) {
  e.preventDefault();
  $('.cart-drawer').removeClass('open_cartdrawer');
  $('body').removeClass('js-drawer-open');
  $('.cart-overlay').hide();
  $('.PageOverlay').removeClass('is-visible');
  $('html').removeClass('no-scroll');
});

$(document).on("click", ".cart-overlay", function (e) {
  e.preventDefault();
  $('.cart-drawer').removeClass('open_cartdrawer');
  $('body').removeClass('js-drawer-open');
  $(this).hide();
  $('.PageOverlay').removeClass('is-visible');
  $('html').removeClass('no-scroll');
});


$(document).on("click", '[data-action="close-drawer"]', function (e) {
// $('.utils__item.header-cart').click(function(e){
  e.preventDefault();
  $('.cart-drawer').removeClass('open_cartdrawer');
  $('body').removeClass('js-drawer-open');
  $('.cart-overlay').hide();
  $('.PageOverlay').removeClass('is-visible');
  $('html').removeClass('no-scroll');
  
});
function carthtmldataGift(){
  $.ajax({
    type: 'GET', 
    url: '/',
    dataType: 'html',
    success: function(cart_html) {
      var cartdrawer_content = $(cart_html).find('#my-sidebar-cart').html();
      $('#my-sidebar-cart').html(cartdrawer_content);
      var cart_count = $(cart_html).find('.cart-count-bubble span[aria-hidden="true"]').html();
      $('.cart-count-bubble span[aria-hidden="true"]').html(cart_count);
    }
  });
}
function carthtmldata(cart){
  $.ajax({
    type: 'GET', 
    url: '/',
    dataType: 'html',
    success: function(cart_html) {

      var cartdrawer_content = $(cart_html).find('#my-sidebar-cart').html();
      $('#my-sidebar-cart').html(cartdrawer_content);
      var cart_count = $(cart_html).find('.cart-count-bubble span[aria-hidden="true"]').html();
      $('.cart-count-bubble span[aria-hidden="true"]').html(cart_count);
      $('.cart-drawer').addClass('open_cartdrawer');
      $('body').addClass('js-drawer-open');
      $('.cart-overlay').show();
       $('.cart__loading').removeClass('ready');
       $('.cart__loading .loading__spinner').addClass('hidden');
updateGiftInCart(cart);
    }
  });
}
function qunatityChange(cart_item, cart_varid){
  $.ajax({
    type: 'POST', 
    url: '/cart/change.js',
    dataType: 'json', 
    data : {
      "quantity": cart_item,
      "id": cart_varid,
    },
    success: function(data) {
      carthtmldata(data);
    }
  });

}

  $(document).on('click', '.upsell-btn', function(event){
  event.preventDefault();
     $('.cart__loading').addClass('ready');
    $('.cart__loading .loading__spinner').removeClass('hidden');
   var id = $(this).parents('.why-not-pro-list').find('[name="id"]').val();
   var data = {
     "quantity": 1,
     "id": id
   };
    // console.log(data);
   $.ajax({
     type: 'POST', 
     url: '/cart/add.js',
     dataType: 'json', 
     data : data,
     success: function() {
      carthtmldata();
     }
 });
});

function addToCart(data) {
console.log(data);
  fetch('/cart/add', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: data
  })
  .then(response => {
    if (!response.ok) {
      return response.json().then(errorData => {
        // Handle specific server errors like product being out of stock
        if (errorData.errors) {
          throw new Error(errorData.errors);  // Throw the error to be caught in the catch block
        } else {
          throw new Error('Something went wrong. Please try again.');
        }
      });
    }
    return response.json();  // Parse the successful response
  })
  .then(cart => {
carthtmldata();
    updateGiftInCart(cart);
//     const html = new DOMParser().parseFromString(cart.sections['cart-drawer'], 'text/html');
//     $('#my-sidebar-cart').html($(html).find('#my-sidebar-cart').html());
//       $('.cart-count-bubble span[aria-hidden="true"]').html(cart.item_count);
//       $('.cart-drawer').addClass('open_cartdrawer');
//       $('body').addClass('js-drawer-open');
//       $('.cart-overlay').show();
//        $('.cart__loading').removeClass('ready');
//        $('.cart__loading .loading__spinner').addClass('hidden');
// document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  })
  .catch(error => {
    console.error('Error:', error);
    // alert(error.message);
    $('.cart__loading').removeClass('ready');
    $('.cart__loading .loading__spinner').addClass('hidden');
  });
}


function cartChange(line, qty){
fetch('/cart/change', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  },
  body: JSON.stringify({
    line: line,
    quantity: qty,
    sections: ["cart-drawer"],
    sections_url: '/'

  })
})
.then(response => response.json())
.then(cart => {
carthtmldata();
  updateGiftInCart(cart);
  // console.log('Success:1', cart);
  // const html = new DOMParser().parseFromString(cart.sections['cart-drawer'], 'text/html');
  // $('#my-sidebar-cart').html($(html).find('#my-sidebar-cart').html());
  // $('.cart-count-bubble span[aria-hidden="true"]').html(cart.item_count);
  // $('.cart__loading').removeClass('ready');
  //      $('.cart__loading .loading__spinner').addClass('hidden');
})
.catch(error => {
  console.error('Error:',error);
   // alert(error.message);
       $('.cart__loading').removeClass('ready');
       $('.cart__loading .loading__spinner').addClass('hidden');
});
}

function drawerPlus(item) {
   $('.cart__loading').addClass('ready');
 $('.cart__loading .loading__spinner').removeClass('hidden');
  var qty = parseInt($(item).prev().val());
  var line = $(item).attr('data-index');
  qty += 1;
  cartChange(line, qty);
}
function drawerMinus(item) {
   $('.cart__loading').addClass('ready');
   $('.cart__loading .loading__spinner').removeClass('hidden');
  var qty = parseInt($(item).next().val());
  var line = $(item).attr('data-index');
  qty -= 1;
  cartChange(line, qty);
}
function drawerInputitem(item) {
   $('.cart__loading').addClass('ready');
  $('.cart__loading .loading__spinner').removeClass('hidden');
  var qty = parseInt($(item).val());
  var line = $(item).attr('data-index');
  cartChange(line, qty);
}
function drawerRemove(item) {
   $('.cart__loading').addClass('ready');
  $('.cart__loading .loading__spinner').removeClass('hidden');
  var line = $(item).attr('data-index');
  cartChange(line, 0);
}


$('.accordions_list > .cart__widget > .cart__widget__content').hide();
    $(document).on('click', '.accordions_list > .cart__widget .cart__widget__title', function(event){
      event.preventDefault();
    if ($(this).parents('.cart__widget').hasClass("active")) {
      $(this).parents('.cart__widget').removeClass("active").find(".cart__widget__content").slideUp();
    } else {
      $(".accordions_list > .cart__widget.active .cart__widget__content").slideUp();
      $(".accordions_list > .cart__widget.active").removeClass("active");
      $(this).parents('.cart__widget').addClass("active").find(".cart__widget__content").slideDown();
    }
    return false;
  }); 






